import React, { useState, useEffect, useRef } from 'react'
import ResizeObserver from 'resize-observer-polyfill'
import { StickyNav } from './styles'

export default (props) => {
  const [scrollable, setScrollable] = useState(props.scrollable || false)
  const [docHeight, setDocHeight] = useState(document.body.getBoundingClientRect().height)
  const ref = useRef(null)

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach( (entry) => {
      const { height } = entry.contentRect
      if (height !== docHeight) {
        setDocHeight(height)
      }
    })
  })

  useEffect(() => {
    resizeObserver.observe(document.body)
    setScrollable(props.scrollable ||
          ref.current.getBoundingClientRect().height > (document.body.clientHeight * 0.94))
    return () => {
      resizeObserver.unobserve(document.body)
    }
  }, [props.children, docHeight])


  return (
    <StickyNav ref={ref} {...{ props, scrollable }} data-testid="scrollable-sticky-topicNav">
      {props.children}
    </StickyNav>
  )
}
